import React from "react"
import "./RoundingMonitorLogo.scss"
import image from "./rounding-monitor-logo.svg"

const RoundingMonitorLogo = () => {
  return (
    <div className="rm-logo">
      <img alt="SwipeSense Logo" src={image} />
    </div>
  )
}

export default RoundingMonitorLogo
